import React from 'react';
import { useReturnStore } from '@src/stores/returnStore';
import { goToNextStep, goToPreviousStep } from '@src/stores/newFlowStore';
import { TagRefundMethodButtonSubmission } from '../../utils/analytics-tagging';
import { ReturnButtons } from '../shared/ReturnButtons';
import { ReturnHeaders } from '../shared/ReturnHeaders';
import { RefundTotal } from '../shared/RefundTotal';
import RefundMethods from './RefundMethods';

const RefundMethodStep = () => {
  const tenders = useReturnStore((state) => state.tenders);
  const militaryExchange = useReturnStore((state) => state.militaryExchange);

  const onButtonContinueClick = () => {
    TagRefundMethodButtonSubmission(tenders?.[0]?.type, militaryExchange);
    goToNextStep();
  };

  return (
    <div className="sui-max-w-[555px]">
      <ReturnHeaders title="Refund details" />
      <div className="sui-flex sui-gap-8 sui-flex-col">
        <RefundMethods />
        <RefundTotal />
      </div>
      <ReturnButtons
        proceedBack={goToPreviousStep}
        proceedNext={onButtonContinueClick}
      />
    </div>
  );
};
export default RefundMethodStep;
